import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>
                <em>2.1 Study area</em>
              </strong>
            </p>
            <p>
              Greater Bangalore, with a spatial extent of 741 km<sup>2</sup>
              ,&nbsp;is the principal administrative, cultural, commercial,
              industrial, and educational capital of the state of Karnataka.
              Bangalore is located at 12&deg; 59&rsquo; N latitude and 77&deg;
              57&rsquo; E longitude, almost equidistant from both the eastern
              and western coasts of the South Indian peninsula, and is situated
              at 920 m above mean sea level. The mean annual total rainfall is
              about 900 mm. The summer temperature ranges from 18 &deg;C to 38
              &deg;C, while the winter temperature ranges from 12 &deg;C to 25
              &deg;C. Thus, Bangalore enjoyed a salubrious climate all year with
              its numerous parks and abundant greenery, known as the
              &rsquo;Garden City&rsquo; of India. Bangalore has an average
              annual rainfall of 859 mm, and temperatures range from 14 &deg;C
              (December to January) to 33 &deg;C (highest from March to May).
              There are two rainy seasons: June to September (southwest monsoon)
              and November to December (northeast monsoon)<sup> 20,21</sup>.
            </p>
            <p>
              The Bangalore landscape is located over ridges, forming three
              watersheds. The undulating terrain in the region has facilitated
              the creation of a large number of interconnected lakes. Bangalore
              has grown spatially more than 10 times since 1951. There have been
              reorganizations with respect to the zones and wards within the
              corporation, rising from 50 divisions in 1949 to 95 wards in the
              1980s, 100 wards in 1995, and now about 150 wards. With the 2006
              notiﬁcation, the Bangalore City Corporation is now reorganized as
              Greater Bangalore City Corporation with 198 wards (for
              decentralized administration at the local level as per the 74
              <sup>th</sup> Amendment of the Indian Constitution). The city is
              now known for its growth in information technology (IT)-based
              industries. With economic liberalization since the early 1990s,
              Bangalore has taken the lead in service-based industries, fueling
              its economic and spatial growth. As a cosmopolitan city, Bangalore
              attracts people and businesses from across the globe, making it a
              leading player in the IT industry<sup>20,21</sup>. With undulating
              terrain, the Bangalore landscape forms three major watersheds:
              Koramangala-Challaghatta Valley, Vrishabhavathi Valley, and Hebbal
              Valley.
            </p>
            <p>
              <strong>
                <em>2.2 Landscape dynamics</em>
              </strong>
            </p>
            <p>
              Temporal remote sensing data (corresponding to the post-monsoon
              period &ndash; November month) were geo-referenced, geometrically
              and radiometrically corrected, and cropped to conform to the
              spatial extent of the study area. Geo-referencing of remote
              sensing data (Landsat Multispectral Sensor - MSS, Thematic Mapper
              - TM and Operational Land Imager - OLI) was done using ground
              control points collected from the field using a pre-calibrated
              Global Positioning System (GPS) and also considering known
              location points (such as road intersections, etc.) collected from
              geo-referenced topographic maps published by the Survey of India
              (https://surveyofindia.gov.in/). Land-use classification using
              remote sensing data involved (a) generation of false color
              composite (FCC), which helped in identifying and locating
              heterogeneous patches of landscapes, (b) selection of training
              data from the FCC corresponding to heterogeneous patches (covering
              at least 15 % of the total area and uniformly distributed over the
              study area), (c) loading of these training data sites as polygon
              features to a GPS for compiling attribute information for the
              training data from the field and online portal with higher spatial
              resolution data (earth.google.com), (d) land-use analysis through
              supervised pattern classifier based on the Gaussian maximum
              likelihood algorithm considering training data (60%, chosen
              randomly representing all land uses), and (e) accuracy assessment
              considering training data (40%) through computation of overall
              accuracy, producer accuracy, user accuracy, and kappa statistics.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>2.3 Spatial distribution of wetlands</em>
              </strong>
            </p>
            <p>
              Wetland delineation was carried out using (i) temporal remote
              sensing data, (ii) field data collected from the field with a
              hand-held pre-calibrated GPS, and (iii) digitizing wetlands from
              the geo-referenced topographic maps of the Survey of India. Google
              Earth data served in the pre-and post-classification processes and
              validation of the results. Fig. 1 depicts the spatial distribution
              of interconnected lakes in Bangalore that have been meeting the
              water demand of domestic, irrigation, livestock rearing, fishing,
              etc.
            </p>
            <p>
              Fig. 2 outlines the method adopted for the design of BLIS, which
              entailed (i) compilation of lake information from literature and
              field survey, (ii) assessment of chemical integrity through water
              quality analyses, (iii) assessment of alteration in the physical
              integrity through encroachment mapping, (iv) inventorying
              biodiversity, and (v) quantification of wetland ecosystem services
              (of 175 lakes) during the study period 2013&ndash;2023, and (v)
              implementation of BLIS. Sampling locations in each lake (of 115
              lakes in Bangalore city) were at (i) inlets, (ii) centre, and (ii)
              outlets based on accessibility, water availability, etc.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis1.png" alt="" />
            </p>
            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 1:</em>
                      </strong>{" "}
                      Lakes of Bangalore, Karnataka.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis2.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 2:</em>
                      </strong>{" "}
                      Method for monitoring lakes of Bangalore.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>2.4 Water quality analyses</em>
              </strong>
            </p>
            <p>
              Monitored quarterly 115 lakes in Bangalore city (Fig. 1) since
              2013 to understand ecological and environmental status. Sampling
              locations in each lake were chosen at (i) inlet, (ii) centre and
              (iii) outlet based on accessibility, water availability, etc.
              Surface water samples were collected and stored in 2L sterile
              polypropylene bottles for and physicochemical analysis at the
              laboratory. Parameters such as water temperature, pH, dissolved
              oxygen, electrical conductivity, and total dissolved solids were
              measured at&nbsp; the sampling location using hand-held
              multi-meter probes. Dissolved oxygen in water samples is estimated
              through Winkler method. Parameters such as total alkalinity, total
              hardness, calcium, magnesium, chloride, biochemical oxygen demand,
              chemical oxygen demand, turbidity, orthophosphate, and nitrate
              were assessed as per the standard protocol<sup>22</sup>&nbsp;at
              the Aquatic Ecology Laboratory (Energy and Wetlands Research
              Group, CES TE15, Indian Institute of Science). These values
              &nbsp;(mean value of three-time sampling) were incorporated in
              BLIS. Biological specimen were identified based on morphological
              keys (referring standard taxonomic literature and online data
              portals) in consultation with the subject experts.
            </p>
            <p>
              <strong>
                <em>2.5 Documentation of biodiversity </em>
              </strong>
            </p>
            <p>
              <strong>2.5.1</strong> Microalgae sampling and identification
            </p>
            <p>
              Microalgae were collected from lake surface water by filtering 50
              litres using a plankton net, fixed with a 4% Lugol iodine
              solution, and concentrated to 50 mL. They were stored in labeled
              plastic bottles and transported to a laboratory for taxonomic
              analysis. Standard morphological keys<sup>23-25</sup> were used to
              identify specimens, which were enumerated using an optical
              microscope at 10 X and 40 X magnifications. Three subsamples were
              counted for each lake sample. Images of microalgae were taken
              using a camera attached to a microscope (Olympus).
            </p>
            <p>
              <strong>2.5.2 </strong>Zooplankton sampling and identification
            </p>
            <p>
              Zooplankton were collected by filtering 50 liters of water using a
              plankton net. Samples were stored in plastic bottles and
              transported for taxonomic analysis. Zooplankton specimen were
              identified up to species level<sup>26</sup> and enumerated using
              an optical microscope at 10 X and 4 X magnifications. Three
              subsamples were counted for each lake sample. Photographs of
              zooplankton were captured with an Olympus camera mounted in the
              microscope.
            </p>
            <p>
              <strong>2.5.3 </strong>Ichthyofauna sampling and identification
            </p>
            <p>
              Ichthyofauna (fish) specimens were collected using gill nets or
              cast nets. Locations were recorded using the Garmin Etrex Global
              Positioning System (GPS), and species were identified using
              morphological keys and literature. Unidentified specimens were
              preserved in a 10% formaldehyde solution. Taxonomic analyses were
              conducted using standard keys in consultation with reference books
              <sup>27-29</sup>. Photographs were taken using a digital camera.
            </p>
            <p>
              <strong>2.5.4 </strong>Macrophyte collection and identification
            </p>
            <p>
              Macrophytes samples were collected randomly through quadrats (100
              cm x 100 cm). These samples were washed, separated, and analyzed
              in a laboratory. Macrophytes were classified based on habitat as
              emergent, rooted, floating, submerged, and free-floating. Species
              were identified using standard morphological keys and literature
              <sup>30,31</sup>. Photographs of macrophyte species were taken
              using a digital camera.
            </p>
            <p>
              <strong>2.5.5 </strong>Bird Diversity Documentation
            </p>
            <p>
              Birds encountered during fieldwork were recorded and archived
              digitally through a digital camera. The birds were identified by
              referring to the field guide and Avibase (
              <a href="https://avibase.bsc-eoc.org/avibase.jsp">
                https://avibase.bsc-eoc.org/avibase.jsp
              </a>
              ).
            </p>
            <p>
              <strong>
                <em>2.6 Bangalore Lakes Information System [BLIS]</em>
              </strong>
            </p>
            <p>
              An information system is conceptualized and implemented using
              Geoserver, PostgreSQL with PostGIS extension, and Leaflet. With
              the spatial information (as per OGC standards) of Bangalore lakes,
              the Bangalore Lakes Information System (BLIS) provides
              geo-visualization of information about lakes in Hebbal-Nagavara,
              Koramangala-Challaghatta, and Vrishabhavathi watersheds of
              Bangalore city from 2013 to 2023 through Web Map Service (WMS) and
              Web Feature Service (WFS). Fig. 3 outlines the schema of BLIS with
              a comprehensive database of attributes pertaining to physical,
              chemical, and biological aspects, including supplementary details
              such as biodiversity, encroachment, and restoration efficacy.
            </p>
            <p>
              The Bangalore Lakes Information System (BLIS) consists of a
              comprehensive database (spatial and attribute), which is crucial
              for monitoring and managing lake health (Fig. 3, 4). The front end
              of BLIS is implemented through HTML (HyperText Markup Language),
              CSS (Cascading Style Sheets), and JavaScript for interactivity,
              data retrieval, and map manipulation. The backend hosts a data
              server, which serves as a gateway for communication. Interactive
              spatial information for visualization is implemented through a
              JavaScript library (Leaflet). GeoServer is an open-source server
              that enables users to share and edit geospatial data, and Leaflet
              is used to create visually appealing and informative maps (Fig.
              3). BLIS (
              <a href="https://wgbis.ces.iisc.ac.in/sdss/BLIS/">
                https://wgbis.ces.iisc.ac.in/sdss/BLIS/
              </a>
              ) provides valuable insights for informed decision-making by
              researchers, policymakers, and stakeholders.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis3.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 3:</em>
                      </strong>{" "}
                      Framework for BLIS.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis4.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 4:</em>
                      </strong>{" "}
                      &nbsp;Decision Support System (DSS) for water quality and
                      aquatic biodiversity in Bangalore lakes.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
